import { useUIStore } from "../store/uiStore";

const kindBg: Record<string, string> = {
  info: "bg-ink",
  success: "bg-primary",
  error: "bg-red-600",
};

export default function Toast() {
  const toast = useUIStore((s) => s.toast);
  if (!toast) return null;
  return (
    <div className="fixed top-6 left-1/2 -translate-x-1/2 z-50 pointer-events-none">
      <div
        className={`${kindBg[toast.kind]} text-white text-sm rounded-full px-5 py-2 shadow-lg`}
      >
        {toast.msg}
      </div>
    </div>
  );
}
